import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { status } from 'constants/general';

import SearchBar from 'modules/common/components/SearchBar/SearchBar';
import categoriesStrings from 'modules/categories/strings';

import initialIcon from 'assets/images/empty-providers.svg';

import Table from 'modules/common/components/Table';
import { TableItemType } from 'modules/common/components/Table/enums';
import themeData from 'utils/theme/themeData';
import AddPricelistServicesModal from 'modules/modals/AddPricelistServicesModal';
import { getServicesTypes } from 'constants/categories';
import { selectedHealthPlanCountrySelector } from 'modules/healthPlans/healthPlansSlice';
import {
  Container,
  Center,
  Img,
  Text,
  Button,
  Wrapper,
  extendTableStyle,
} from './ScansServicesComponent.style';

const ScansServicesComponent = ({
  isCreateServiceModalHidden,
  setIsCreateServiceModalHidden,
  searchQuery,
  handleSearchBarInputChange,
  handleShowMoreClick,
  handleRemoveService,
  priceListId,
}) => {
  const [servicesData, setServicesData] = useState([]);
  const [servicesRecords, setServicesRecords] = useState([]);
  const selectedHealthPlanCountry = useSelector(selectedHealthPlanCountrySelector);
  const services = useSelector(state => state.categories.services);

  const getMainRowItems = () => {
    const rows = [];
    services.data?.forEach(item => {
      const { id, productName, priceValue, discountTypeId } = item;
      const servicesTypes = getServicesTypes(selectedHealthPlanCountry?.currency?.name);
      const currentType = servicesTypes[discountTypeId].label;
      rows.push({
        id,
        rowData: item,
        rowContent: [
          {
            itemContent: productName,
            itemType: TableItemType.Text,
            isItemClickable: false,
          },
          {
            itemContent: `${priceValue} ${currentType}`,
            itemType: TableItemType.Text,
            isItemClickable: false,
          },
        ],
        editButtons: [
          {
            btnId: 1,
            btnIcon: '"\\e91d"',
            btnLabel: 'Remove',
            btnFn: () => handleRemoveService(item),
            btnTextColor: themeData.colors.redMain,
          },
        ],
      });
    });

    return rows;
  };

  useEffect(() => {
    setServicesData(services.data);
  }, [services.data]);

  useEffect(() => {
    setServicesRecords(() => getMainRowItems());
  }, [servicesData]);

  return (
    <Container>
      {services.status === status.SUCCESS && services.data.length === 0 && !searchQuery ? (
        <Center>
          <Img src={initialIcon} />
          <Text>{categoriesStrings.medicalServices.emptyState}</Text>
          <Button onClick={() => setIsCreateServiceModalHidden(false)}>
            {categoriesStrings.medicalServices.addServices}
          </Button>
        </Center>
      ) : (
        <Wrapper>
          <Button
            style={{ marginLeft: 'auto' }}
            onClick={() => setIsCreateServiceModalHidden(false)}
          >
            {categoriesStrings.medicalServices.addServices}
          </Button>
          <SearchBar
            searchQuery={searchQuery}
            handleSearchBarInputChange={handleSearchBarInputChange}
            testId="healthplansearch"
          />
          <Table
            latestDataLength={services.latestDataLength}
            dataStatus={services.status}
            columns={categoriesStrings.medicalServicesTable.gridHeaderList}
            rows={servicesRecords}
            searchQuery={searchQuery}
            handleShowMoreClick={handleShowMoreClick}
            extendTableStyle={extendTableStyle}
          />
        </Wrapper>
      )}

      {!isCreateServiceModalHidden && (
        <AddPricelistServicesModal
          onClose={() => setIsCreateServiceModalHidden(true)}
          priceListId={priceListId}
          modalStrings={categoriesStrings.addServicesModal}
          categoryKey="Scans"
        />
      )}
    </Container>
  );
};

ScansServicesComponent.propTypes = {
  isCreateServiceModalHidden: PropTypes.bool.isRequired,
  setIsCreateServiceModalHidden: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  servicesQueryString: PropTypes.shape({
    healthPlanId: PropTypes.number,
    categoryId: PropTypes.number,
    pageNumber: PropTypes.number,
    pagesize: PropTypes.number,
    active: PropTypes.bool,
  }).isRequired,
  handleRemoveService: PropTypes.func.isRequired,
};

export default ScansServicesComponent;
